import { englishText } from '../../connectors/Localization/englishText';

type TranslationKey = keyof typeof englishText;

type SaveErrorNotificationKeys = {
	title: TranslationKey;
	description: TranslationKey;
};

/**
 * Maps a backend `errorCode` (from the image-gen-svc `ApiErrorResponse`) to the
 * localized notification keys shown when saving an enhancement fails. Unknown or
 * missing codes fall back to the generic save-error copy.
 */
const SAVE_ERROR_CODE_KEYS: Record<string, SaveErrorNotificationKeys> = {
	technical_error: {
		title: 'generateWithPrompt.save-notification.error.code.technical_error.title',
		description: 'generateWithPrompt.save-notification.error.code.technical_error.description',
	},
	file_type_not_supported: {
		title: 'generateWithPrompt.save-notification.error.code.file_type_not_supported.title',
		description:
			'generateWithPrompt.save-notification.error.code.file_type_not_supported.description',
	},
	output_max_tokens_exceeded: {
		title: 'generateWithPrompt.save-notification.error.code.output_max_tokens_exceeded.title',
		description:
			'generateWithPrompt.save-notification.error.code.output_max_tokens_exceeded.description',
	},
	file_size_exceeded: {
		title: 'generateWithPrompt.save-notification.error.code.file_size_exceeded.title',
		description:
			'generateWithPrompt.save-notification.error.code.file_size_exceeded.description',
	},
	guardrail_input_violation: {
		title: 'generateWithPrompt.save-notification.error.code.guardrail_input_violation.title',
		description:
			'generateWithPrompt.save-notification.error.code.guardrail_input_violation.description',
	},
	guardrail_output_violation: {
		title: 'generateWithPrompt.save-notification.error.code.guardrail_output_violation.title',
		description:
			'generateWithPrompt.save-notification.error.code.guardrail_output_violation.description',
	},
	thumbnail_not_ready: {
		title: 'generateWithPrompt.save-notification.error.code.thumbnail_not_ready.title',
		description:
			'generateWithPrompt.save-notification.error.code.thumbnail_not_ready.description',
	},
};

const FALLBACK_KEYS: SaveErrorNotificationKeys = {
	title: 'generateWithPrompt.save-notification.error.title',
	description: 'generateWithPrompt.save-notification.error.description',
};

export function getSaveErrorNotificationKeys(
	errorCode: string | undefined,
): SaveErrorNotificationKeys {
	if (errorCode && errorCode in SAVE_ERROR_CODE_KEYS) {
		return SAVE_ERROR_CODE_KEYS[errorCode];
	}

	return FALLBACK_KEYS;
}
